var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('mail-box-nav',{ref:"mailBoxNav",attrs:{"currentNum":_vm.currentNum},on:{"clearData":_vm.clearData}}),_c('router-view',{on:{"updateEmailNum":_vm.updateEmailNum,"updateEmailUnread":_vm.handleEmailUnread,"sendOk":_vm.sendOk}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }